import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Compass, Menu, X } from "lucide-react";

const LINKS = [
  { label: "What we do", id: "services" },
  { label: "Who we help", id: "who" },
  { label: "Set-departure", id: "tours" },
  { label: "Signature events", id: "events" },
  { label: "Gallery", id: "gallery" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${scrolled ? "bg-brand-navy/85 backdrop-blur-xl border-b border-brand-teal/20" : ""}`}
      data-testid="site-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <button onClick={() => scrollTo("hero")} className="flex items-center gap-3 group" data-testid="logo-home-link">
          <Compass className="w-6 h-6 text-brand-aqua group-hover:rotate-45 transition-transform duration-700" />
          <span className="font-serif text-lg tracking-tight text-brand-sand">WayFinder <span className="text-brand-teal">Pacific</span></span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => scrollTo(l.id)} data-testid={`nav-${l.id}`}
              className="font-sans text-sm text-brand-sand/70 hover:text-brand-aqua transition-colors">
              {l.label}
            </button>
          ))}
          <button onClick={() => scrollTo("contact")} data-testid="nav-contact-cta"
            className="font-sans text-sm px-5 py-2.5 bg-brand-coral text-brand-navy font-medium hover:bg-brand-sand transition-colors">
            Plan with us
          </button>
        </nav>

        <button className="lg:hidden text-brand-sand" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-brand-navy/95 backdrop-blur-xl border-t border-brand-teal/20 px-6 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => { scrollTo(l.id); setOpen(false); }}
              className="text-left font-sans text-brand-sand/80 py-1" data-testid={`mobile-nav-${l.id}`}>{l.label}</button>
          ))}
          <button onClick={() => { scrollTo("contact"); setOpen(false); }}
            className="mt-2 px-5 py-3 bg-brand-coral text-brand-navy font-medium" data-testid="mobile-nav-contact-cta">Plan with us</button>
        </div>
      )}
    </motion.header>
  );
};
